import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Subject, BehaviorSubject } from 'rxjs';
import { Numbers } from 'src/app/utils/constants';

@Component({
  selector: 'app-step-menu',
  templateUrl: './steps-menu.component.html',
  styleUrls: ['./steps-menu.component.scss']
})
export class StepsMenuComponent implements OnInit, OnDestroy {

  /**
   * @description Es el paso
   */
  @Input() STEP: BehaviorSubject<any>;
  @Input() TYPE: string;
  currentStep: number = Numbers.number0;

  private finish = new Subject();
  nameForm = '';
  isLegal = false;
  isLegalOwner = false;

  //#region Constructor
  /**
   * @ignore
   */
  constructor(
  ) {
  }
  /**
   * @ignore
   */
  ngOnInit(): void {
    this.initStep();
    this.nameForm = this.TYPE;
    this.isLegal = false;
    if (this.nameForm === 'particularLegalAsistance' || this.nameForm === 'ownerLegalAsistance') { this.isLegal = true; }
    this.isLegalOwner = false;
    if (this.nameForm === 'ownerLegalAsistance') { this.isLegalOwner = true; }
  }
  /**
   * @ignore
   */
  ngOnDestroy(): void {
    this.finish.next(true);
  }

  /**
   * @description Inicializacion del paso
   */
  private initStep(): void {
    this.STEP.pipe(
      takeUntil(this.finish)
    ).subscribe(num => { this.currentStep = num; });
  }

}
